import type { APISection } from '../../sections/types';
import { normalizeSections } from '../utils/normalizeSections';
import type { ContestManageStore } from '../types/store';
import { flattenArray } from '../utils/flattenArray';

import { parseFieldResponse } from './parseFieldResponse';

export const parseInitialResponse = (sections: APISection[]): ContestManageStore => {
  const normalizedData = normalizeSections(sections);

  const store: ContestManageStore = {
    sectionsKeys: [],
    sections: {},
    fields: {},
    fieldsCache: {},
    sectionsCache: {},
  };
  normalizedData.sections.forEach((section) => {
    store.sectionsKeys.push(section.key);

    switch (section.type) {
      case 'BaseSection': {
        store.sections[section.key] = {
          key: section.key,
          type: 'BaseSection',
          data: section,
        };
        break;
      }
      case 'DynamicSection': {
        store.sections[section.key] = {
          ...section,
        };
        break;
      }
      case 'DynamicSections': {
        store.sections[section.key] = {
          ...section,
        };
        break;
      }
      default: {
        // eslint-disable-next-line no-console
        console.log('Unknown section type', section);
      }
    }
  });

  normalizedData.fields.forEach((field) => {
    const parsedField = parseFieldResponse(field);
    if (!parsedField) {
      // eslint-disable-next-line no-console
      console.log('Unknown field type', field);

      // Remove field from section
      const sectionWithField = normalizedData.sections.find(
        (section) => section.type === 'BaseSection' && section.fields.includes(field.key)
      );
      if (!sectionWithField || sectionWithField.type !== 'BaseSection') {
        return;
      }
      sectionWithField.fields = sectionWithField.fields.filter(
        (fieldKey) => fieldKey !== field.key
      );
      return;
    }

    flattenArray(parsedField).forEach((fieldQuery) => {
      store.fields[fieldQuery.key] = fieldQuery;
    });
  });

  return store;
};
